import { useContext } from 'react';

import { Divider, Flex, Stack } from '@mantine/core';

import { AppContext } from '@/contexts/AppContext/AppContextProvider';

import { UserCard, UserRating, UserReplace } from '@/entities/User';
import UserProfileMenu from '@/entities/User/UserProfileMenu.tsx';

export const UserProfile = () => {
	const { admin, moderator } = useContext(AppContext);

	return (
		<Flex direction="column">
			<Stack>
				<UserCard detail />
				<UserRating />
				{(admin || moderator) && <UserReplace />}
				<Divider />
				<UserProfileMenu />
			</Stack>
		</Flex>
	);
};
